import { Phone, Mail, MapPin, Clock, MessageCircle, CalendarDays } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";
import { BRAND } from "@/data/content";
import { useBooking } from "@/lib/booking";

export function Contact() {
  const { openBooking } = useBooking();
  const rows = [
    { icon: Phone, label: "Phone", value: BRAND.phone },
    { icon: MessageCircle, label: "WhatsApp", value: BRAND.phone },
    { icon: Mail, label: "Email", value: BRAND.email },
    { icon: MapPin, label: "Clinic Address", value: BRAND.address },
    { icon: Clock, label: "Opening Hours", value: BRAND.hours },
  ];
  return (
    <section id="contact" data-testid="contact-section" className="py-24 lg:py-32 bg-ivory">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <SectionHeading
          chapter="13"
          overline="Contact"
          title="Let's Talk About Your Healthcare Needs"
          sub={`Dyntra Clinics — Sector 75, Noida · Owner: Dr. Ankita Pandey`}
        />
        <div className="mt-14 grid lg:grid-cols-2 gap-8 items-stretch">
          <Reveal>
            <div className="h-full rounded-3xl bg-pine-deep text-ivory p-8 md:p-10 shadow-grand relative overflow-hidden grain">
              <div className="space-y-5">
                {rows.map((r) => (
                  <div key={r.label} className="flex items-start gap-4">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white/10 text-gold">
                      <r.icon className="h-5 w-5" strokeWidth={1.8} />
                    </span>
                    <div>
                      <p className="text-[11px] uppercase tracking-[0.2em] font-bold text-gold">{r.label}</p>
                      <p className="mt-1 text-sm font-semibold text-ivory/90">{r.value}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-10 flex flex-wrap gap-3">
                <a data-testid="contact-call-cta" href={BRAND.phoneLink} className="inline-flex items-center gap-2 rounded-full bg-gold px-6 py-3.5 text-sm font-bold text-pine-deep transition-all duration-300 hover:bg-gold-soft">
                  <Phone className="h-4 w-4" /> Call Now
                </a>
                <a data-testid="contact-whatsapp-cta" href={BRAND.whatsapp} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-6 py-3.5 text-sm font-bold text-white transition-all duration-300 hover:brightness-110">
                  <MessageCircle className="h-4 w-4" /> WhatsApp Us
                </a>
                <button data-testid="contact-book-cta" onClick={() => openBooking()} className="inline-flex items-center gap-2 rounded-full border border-ivory/25 px-6 py-3.5 text-sm font-bold text-ivory transition-all duration-300 hover:bg-ivory/10">
                  <CalendarDays className="h-4 w-4" /> Book Appointment
                </button>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="h-full min-h-[380px] overflow-hidden rounded-3xl border border-pine/10 shadow-lift">
              <iframe
                data-testid="contact-map"
                title="Dyntra Clinics — Sector 75, Noida on Google Maps"
                src="https://www.google.com/maps?q=Futech%20Gateway%2C%20Plot%20GH-10%2C%20Sector%2075%2C%20Noida%2C%20Uttar%20Pradesh%20201301&output=embed"
                className="h-full w-full min-h-[380px] grayscale-[35%] contrast-[1.05]"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
